import { Navigate, Outlet } from "react-router-dom";

export default function PublicRoute() {
  let dealer = null;

  try {
    const raw = localStorage.getItem("dealer");
    dealer = raw ? JSON.parse(raw) : null;
  } catch {
    dealer = null;
  }

  const roleRaw = localStorage.getItem("role");
  const isLoggedIn = !!dealer && !!roleRaw;

  if (!isLoggedIn) {
    return <Outlet />;
  }

  return <Navigate to="/login-success" replace />;
}